import { type FC } from "react";
import { LuSend } from "react-icons/lu";
import { ButtonProps, HStack, Icon } from "@chakra-ui/react";

import { Button } from "@/components/ui/button";
import { useCreateOrderForm } from "../lib/create-order-context";

interface Props extends Partial<ButtonProps> {
  onClose: () => unknown;
  onSubmitted?: () => void;
  caption?: string;
}

export const CreateOrderSubmissionControls: FC<Props> = ({
  onClose,
  onSubmitted,
  caption,
  ...props
}) => {
  const { isSubmitting, isValid, submitForm } = useCreateOrderForm();

  return (
    <HStack justify="flex-end" gap={2}>
      <Button variant="ghost" onClick={onClose}>
        Close
      </Button>
      <Button
        disabled={!isValid}
        loading={isSubmitting}
        onClick={() =>
          submitForm().then(() => {
            onClose();
            onSubmitted?.();
          })
        }
        w="full"
        {...props}
      >
        {caption || "Create order"}
      </Button>
    </HStack>
  );
};
